import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized-contact',
  templateUrl: './unauthorizedContact.component.html',
  styleUrls: ['./unauthorized.component.css'],

  imports: [TranslateModule]
})
export class UnauthorizedContactComponent implements OnInit {
  codeErreur: string;
  timeError: boolean;
  timeIat: string;

  private route = inject(ActivatedRoute);
  private oauthService = inject(OAuthService);
  private storageService = inject(StorageService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.codeErreur = params['code'];
      if (params['iat']) {
        const d = new Date(0);
        d.setUTCSeconds(params['iat']);
        this.timeIat = d.toLocaleTimeString();
        this.timeError = this.codeErreur === 'ERR-05' ? true : false;
      }
    });
  }

  logout() {
    this.storageService.clearStorage();
    this.oauthService.logOut();
  }
}
